import { ICheckbox } from './checkbox.interface'
import { useEffect, useState } from 'react'
import './checkbox.style.css'

function Checkbox<T>({
    isChecked = false,
    value,
    onChecked,
    disabled,
    click,
}: ICheckbox<T>) {
    const [checked, setChecked] = useState(false)
    const disabledClass = disabled ? 'opacity-50' : ''

    useEffect(() => {
        setChecked(isChecked)
    }, [isChecked])

    return (
        <input
            className={`rounded-logistical-radius-2 cursor-pointer loglines-checkbox themes-border-color ${disabledClass}`}
            type="checkbox"
            checked={checked}
            onClick={() => {
                const val: boolean = !checked
                setChecked(val)
                if (val === true) {
                    onChecked(value ?? true)
                } else {
                    onChecked(false)
                }
                if (click) {
                    click()
                }
            }}
            onChange={() => {}}
            disabled={disabled}
        />
    )
}

export default Checkbox
